<template>
  <section class="px-6 pt-5 pb-5.5 bg-background border-t border-border">
    <div class="flex items-center gap-3 mb-4">
      <span class="flex-1 h-px bg-border" />
      <span class="text-xs font-bold uppercase tracking-ds-caps text-muted-foreground">
        or
      </span>
      <span class="flex-1 h-px bg-border" />
    </div>

    <div class="flex flex-col gap-6 lg:flex-row lg:items-stretch">
      <div
        v-if="isAIEnabled"
        class="flex-1 min-w-0"
      >
        <h3 class="mb-0.5 text-base font-bold text-foreground">
          Type what happened
        </h3>
        <p class="mb-3 text-xs font-medium text-muted-foreground">
          For everything a feed cannot see: property, art, private funds, loans, vehicles, entities.
        </p>

        <AddAssetComposerField @describe="emit('describe', $event)" />
      </div>

      <div
        class="flex flex-col shrink-0"
        :class="isAIEnabled ? 'lg:w-100' : 'flex-1'"
      >
        <h4 class="mb-2.5 text-xs font-bold uppercase tracking-ds-caps text-muted-foreground">
          Start a wizard yourself
        </h4>
        <div class="flex flex-wrap gap-2">
          <DSButton
            v-for="option in WIZARD_FLOWS"
            :key="option"
            variant="secondary"
            size="sm"
            class="border-border font-medium"
            @click="handlePickFlow(option)"
          >
            <component
              :is="WIZARD_BY_FLOW[option].icon"
              class="size-3.5"
            />
            {{ WIZARD_BY_FLOW[option].label }}
          </DSButton>
        </div>
        <p class="flex gap-2 mt-auto pt-4.5 text-xs font-medium leading-normal text-muted-foreground">
          <Lock class="size-3.5 shrink-0 mt-0.5" />
          Typed entries stay in this repository. Connected feeds are read-only.
        </p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Lock } from '@lucide/vue'

import { DSButton } from '@ds'

import { AssetWizardFlow } from '@/store/ai/assetWizard/utils/types'

import { useSettingsStore } from '@/store/settings'

import { WIZARD_BY_FLOW, WIZARD_FLOWS } from '../Wizards/utils/registry'
import AddAssetComposerField from './AddAssetComposerField.vue'

const emit = defineEmits<{
  (e: 'describe', sentence: string): void
  (e: 'pick-flow', flow: AssetWizardFlow): void
}>()

const settingsStore = useSettingsStore()

const isAIEnabled = computed(() => settingsStore.getAIAgent)

const handlePickFlow = (flow: AssetWizardFlow) => {
  emit('pick-flow', flow)
}
</script>
